import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

/**
 * Logs a Firebase Analytics event if analytics is available.
 * @param {string} eventName - The name of the event (e.g., 'notification_received').
 * @param {object} [params] - Optional event parameters.
 */
export const logFirebaseEvent = (eventName, params = {}) => {
  if (!analytics) {
    console.warn("Firebase Analytics not initialized.");
    return;
  }

  try {
    logEvent(analytics, eventName, params);
  } catch (err) {
    console.error("Error logging Firebase event:", err);
  }
};